module.exports = __webpack_public_path__ + "69e6195ca41853b638d063d16336c195.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/handlebars-template-loader/file-loader.js?url=honeybadger_logo.svg!./src/honeybadger_logo.svg
// module id = 148
// module chunks = 0